// Shared recovery guidance for preflight and reactive AI quota dialogs.
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useStaffPermissions } from '@/composables/useStaffPermissions'
import { useVendorPortalScope } from '@/composables/useVendorPortalScope'
import { STAFF_PERMISSIONS } from '@/shared/permissions'

export function useAiQuotaRecovery(nextResetAt: () => string | null | undefined) {
  const { t, locale } = useI18n()
  const router = useRouter()
  const { can } = useStaffPermissions()
  const { isVendorScoped } = useVendorPortalScope()
  const canConfigure = computed(() => !isVendorScoped.value && can(STAFF_PERMISSIONS.settingsWrite))
  const resetText = computed(() => {
    const value = nextResetAt()
    const date = value ? new Date(value) : null
    if (!date || !Number.isFinite(date.getTime())) return t('common.aiAccess.resetUnknown')
    return t('common.aiAccess.resetAt', {
      date: new Intl.DateTimeFormat(locale.value, { dateStyle: 'long', timeStyle: 'short' }).format(date),
    })
  })
  const recoveryText = computed(() => t(canConfigure.value ? 'common.aiAccess.ownKeyHelp' : 'common.aiAccess.contactAdmin'))
  function configureKey() {
    if (!canConfigure.value) return
    return router.push({ path: '/settings', query: { tab: 'ai' } })
  }
  return { canConfigure, resetText, recoveryText, configureKey }
}
